import { ClipboardList, HeartPulse, Mic, Pill } from 'lucide-react';
import { useAnimationLoop } from './useOnboardingAnim';
import { DEMO_ROOT_CLASS } from './onboardingLayout';

const WELCOME_PHASES = [900, 900, 900, 900, 1200];

const NOTE_TYPES = [
  { label: 'Progress', icon: ClipboardList, className: 'bg-primary' },
  { label: 'Vitals', icon: HeartPulse, className: 'bg-vitals' },
  { label: 'MAR', icon: Pill, className: 'bg-mar' },
  { label: 'Handover', icon: ClipboardList, className: 'bg-handover' },
];

export default function WelcomeDemoAnimation() {
  const phase = useAnimationLoop(WELCOME_PHASES);

  return (
    <div className={`${DEMO_ROOT_CLASS} relative`}>
      <div className="relative flex h-full w-full max-w-full flex-col items-center justify-center sm:max-w-[240px]">
      <div
        className={`absolute h-28 w-28 rounded-full bg-gradient-to-br from-[#1E40AF] to-[#60A5FA] transition-all duration-700 ${
          phase >= 0 ? 'scale-110 opacity-40 blur-sm' : 'scale-90 opacity-20'
        }`}
      />
      <div
        className={`relative mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary text-white shadow-lg transition-transform duration-500 ${
          phase >= 0 ? 'scale-100' : 'scale-90'
        }`}
      >
        <Mic className="h-8 w-8" strokeWidth={2} />
      </div>
      <div className="flex flex-wrap justify-center gap-1.5 px-2">
        {NOTE_TYPES.map((type, index) => {
          const Icon = type.icon;
          const visible = phase >= index;
          return (
            <span
              key={type.label}
              className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[9px] font-semibold text-white transition-all duration-400 ${
                type.className
              } ${visible ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`}
            >
              <Icon className="h-2.5 w-2.5" />
              {type.label}
            </span>
          );
        })}
      </div>
      </div>
    </div>
  );
}
